import React from 'react'

const LoaderGIF = () => (
  <section className="spinner-container">
    <div className="gif"></div>
  </section>
)

export default React.memo(LoaderGIF)
